import { UPDATE_STATUS } from "../Defs/statusdefs";

const initialState = {
  status: "idle", // initial status can be 'idle'
  source: "application",
};

const updateStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATUS:
      if (typeof action.payload === "string") {
        return {
          ...state,
          status: action.payload,
          source: "application",
        };
      }
      return {
        ...state,
        status: action.payload.status,
        source: action.payload.source || "application",
      };
    default:
      return state;
  }
};

export default updateStatusReducer;
